export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1680992046615-065f58bcb4d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHw0fHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMHNlcnZlciUyMHJvb20lMjBkYXJrJTIwbmVvbiUyMGN5YW4lMjBzaGllbGQlMjBkYXRhJTIwZGVmZW5zZXxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
  serverRack: "https://images.unsplash.com/photo-1639066648921-82d4500abf1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMHNlcnZlciUyMHJvb20lMjBkYXJrJTIwbmVvbiUyMGN5YW4lMjBzaGllbGQlMjBkYXRhJTIwZGVmZW5zZXxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
  analyst: "https://images.unsplash.com/photo-1549605659-32d82da3a059?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxjeWJlciUyMHNlY3VyaXR5JTIwaGFja2VyJTIwY29kZSUyMHNjcmVlbiUyMGRhcmslMjBwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwdGVjaHxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
  code: "https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxjeWJlciUyMHNlY3VyaXR5JTIwaGFja2VyJTIwY29kZSUyMHNjcmVlbiUyMGRhcmslMjBwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwdGVjaHxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
  cables: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMHNlcnZlciUyMHJvb20lMjBkYXJrJTIwbmVvbiUyMGN5YW4lMjBzaGllbGQlMjBkYXRhJTIwZGVmZW5zZXxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Inteligencia Artificial", to: "/inteligencia-artificial" },
  { label: "Servicios", to: "/servicios" },
  { label: "Casos de éxito", to: "/casos-de-exito" },
  { label: "Cumplimiento", to: "/cumplimiento" },
  { label: "Guía de incidentes", to: "/guia-de-incidentes" },
  { label: "Ecosistema", to: "/ecosistema" },
  { label: "Noticias", to: "/noticias" },
];

export const METRICS = [
  { value: 120, suffix: "+", label: "Organizaciones acompañadas" },
  { value: 40, suffix: "+", label: "Proyectos de IA en producción" },
  { value: 99.9, suffix: "%", label: "Disponibilidad del SOC", decimals: 1 },
  { value: 15, suffix: " min", label: "Tiempo medio de respuesta" },
];

export const MARQUEE_ITEMS = [
  "Consultoría de IA",
  "Machine Learning",
  "Agentes conversacionales",
  "Visión artificial",
  "Automatización de procesos",
  "Analítica predictiva",
  "IA responsable",
  "AI Act",
  "Gobierno del dato",
  "SOC 24/7",
];

export const HOME_HIGHLIGHTS = [
  {
    to: "/inteligencia-artificial",
    kicker: "Entender",
    title: "Qué es la IA y qué puede hacer por ti",
    text: "Machine Learning, lenguaje natural, visión artificial, IA generativa y predictiva: cómo funciona cada modalidad, qué algoritmos hay detrás y cómo elegir la adecuada para tu problema.",
  },
  {
    to: "/servicios",
    kicker: "Aplicar",
    title: "Servicios de IA y ciberseguridad",
    text: "Del análisis de viabilidad al modelo en producción: preparamos los datos, construimos, evaluamos, desplegamos de forma segura y vigilamos para que la IA rinda desde el primer mes.",
  },
  {
    to: "/cumplimiento",
    kicker: "Cumplir",
    title: "AI Act, RGPD, ENS y NIS2",
    text: "Una IA responsable se puede explicar, auditar y supervisar: documentamos datos y modelos, analizamos sesgos y dejamos evidencia del cumplimiento normativo.",
  },
];

export const AI_PILLARS = [
  {
    id: "ml",
    label: "Machine Learning",
    title: "Sistemas que aprenden de tus datos",
    text: "En lugar de programar todas las reglas una por una, se entrena un modelo con datos históricos para que aprenda patrones y los aplique a casos nuevos. Si quieres saber qué clientes pueden darse de baja, el modelo aprende qué combinaciones de antigüedad, uso, incidencias y reclamaciones suelen anticipar el abandono, y te avisa a tiempo para actuar.",
    points: ["Detección de fraude y operaciones sospechosas", "Predicción de ventas y de abandono de clientes", "Clasificación de documentos e incidencias", "Segmentación de usuarios y análisis de riesgo"],
  },
  {
    id: "deep",
    label: "Deep Learning",
    title: "Redes neuronales para datos complejos",
    text: "Una modalidad avanzada del Machine Learning basada en redes neuronales de muchas capas que procesan la información de forma progresiva: las primeras detectan formas simples y las últimas toman la decisión. Es la tecnología que permite trabajar con imágenes, audio, texto o vídeo, a cambio de necesitar más datos y capacidad de cálculo.",
    points: ["Reconocimiento de voz e imágenes", "Detección de defectos en piezas industriales", "Comprensión y generación de lenguaje", "Patrones que las técnicas clásicas no ven"],
  },
  {
    id: "lenguaje",
    label: "Lenguaje natural",
    title: "Máquinas que entienden lo que se escribe",
    text: "Gran parte de la información de una organización está en texto: correos, informes, contratos, chats, reseñas o tickets de soporte. El procesamiento del lenguaje natural (NLP) permite analizarlo, extraer datos, clasificar mensajes, resumir documentos largos o detectar los temas que más se repiten, combinando técnicas lingüísticas, estadísticas y de aprendizaje automático.",
    points: ["Clasificación automática de reclamaciones", "Extracción de datos de contratos y facturas", "Análisis de opinión de clientes", "Resumen de documentación extensa"],
  },
  {
    id: "vision",
    label: "Visión artificial",
    title: "Convertir píxeles en información útil",
    text: "La visión artificial analiza imágenes y vídeo para identificar objetos, defectos, patrones o situaciones concretas. No consiste solo en «ver»: el sistema clasifica imágenes, localiza objetos, segmenta zonas y sigue movimientos. En una línea de fabricación, una cámara y un modelo pueden revisar cada pieza y detectar soldaduras incorrectas o errores de montaje.",
    points: ["Control de calidad en producción", "Apoyo al análisis de imágenes médicas", "Detección de accesos o comportamientos anómalos", "Análisis de cultivos, estanterías o flujos de personas"],
  },
  {
    id: "generativa",
    label: "IA generativa",
    title: "Contenido y conocimiento a demanda",
    text: "Modelos capaces de crear contenido nuevo a partir de patrones aprendidos: redactar la primera versión de un informe, resumir expedientes, generar materiales formativos o proponer código. Funciona mejor como apoyo que acelera tareas que como sustituto del conocimiento experto: sus respuestas pueden contener errores o información inventada, así que siempre debe haber revisión humana cuando el contenido tiene impacto técnico, legal o económico.",
    points: ["Borradores de documentos e informes", "Materiales formativos y explicaciones didácticas", "Ideas para campañas y comunicación", "Apoyo a la programación y la documentación técnica"],
  },
  {
    id: "agentes",
    label: "IA conversacional",
    title: "Agentes que conversan y ejecutan tareas",
    text: "Chatbots, asistentes virtuales y agentes capaces de mantener una conversación, responder preguntas o ejecutar tareas en lenguaje natural. Para que sean útiles no basta con que respondan con fluidez: deben entender el contexto, reconocer sus límites, evitar respuestas inventadas y derivar a una persona cuando el caso lo requiere.",
    points: ["Atención al cliente y consulta de pedidos", "Búsqueda de información interna", "Clasificación de correos y solicitudes", "Tramitación administrativa asistida"],
  },
  {
    id: "predictiva",
    label: "Analítica predictiva",
    title: "Anticipar lo que va a ocurrir",
    text: "La IA predictiva estima lo que puede pasar a partir de datos históricos: demanda, averías, cargas de trabajo, riesgos o retrasos. Es de las aplicaciones más rentables porque ayuda a planificar mejor. Eso sí, una predicción nunca es una certeza: debe acompañarse de métricas de error, revisión periódica y actualización del modelo cuando cambian las circunstancias.",
    points: ["Previsión de demanda e inventario", "Mantenimiento predictivo de maquinaria", "Detección de anomalías en tiempo real", "Planificación de recursos y turnos"],
  },
  {
    id: "segura",
    label: "IA segura",
    title: "Innovación con garantías",
    text: "Un modelo publicado como servicio recibe datos sensibles e influye en decisiones reales, así que la seguridad empieza en el diseño: control de acceso por identidad, comunicaciones cifradas, validación de las entradas, registros sin datos sensibles, versiones de modelo controladas y un plan de retirada. Cada despliegue se evalúa además contra el AI Act, el RGPD y los marcos de ciberseguridad.",
    points: ["Gobierno del dato y minimización", "Control de accesos y cifrado", "Trazabilidad de las respuestas", "Monitorización de uso, errores y calidad"],
  },
];

export const AI_APPLICATIONS = [
  { sector: "Empresas y comercio", text: "Recomendación de productos, previsión de ventas, segmentación de clientes, detección de abandono y análisis de opiniones para decidir con datos y no por intuición." },
  { sector: "Industria", text: "Mantenimiento predictivo con datos de sensores (temperatura, vibración, presión), visión artificial para control de calidad y alertas ante comportamientos anómalos de la maquinaria." },
  { sector: "Banca y seguros", text: "Detección de operaciones sospechosas por importe, país u horario, valoración de riesgo y clasificación de solicitudes con modelos explicables ante el auditor." },
  { sector: "Sanidad", text: "Apoyo al análisis de imágenes médicas y priorización de casos, siempre como herramienta de ayuda al profesional y con supervisión humana en cada decisión." },
  { sector: "Centros formativos", text: "Tutores virtuales, recomendación de contenidos, generación de materiales y evaluación asistida con supervisión docente." },
  { sector: "Administraciones", text: "Tramitación ágil, asistentes ciudadanos, clasificación de expedientes y análisis de servicios públicos conforme al ENS y al AI Act." },
];

export const SERVICES = [
  {
    icon: "cpu",
    title: "Consultoría e implantación de IA",
    text: "Antes de elegir tecnología analizamos el problema real: qué decisión quieres mejorar, qué datos tienes, cuánto cuesta equivocarse, qué nivel de explicación necesitas y qué retorno cabe esperar. A veces la respuesta es un modelo; a veces, una regla de negocio bien diseñada.",
    points: ["Análisis de viabilidad y ficha del problema", "Selección justificada de enfoque y algoritmo", "Prueba de concepto acotada antes de invertir", "Puesta en producción con métricas de éxito"],
  },
  {
    icon: "chart",
    title: "Analítica de datos y modelos predictivos",
    text: "Convertimos datos dispersos en decisiones: exploramos y limpiamos la información, construimos modelos de clasificación, regresión, agrupamiento o detección de anomalías y los presentamos en paneles comprensibles para dirección.",
    points: ["Exploración y preparación de datos", "Modelos predictivos y de segmentación", "Evaluación por segmentos, no solo global", "Paneles y cuadros de mando"],
  },
  {
    icon: "bot",
    title: "Agentes y chatbots conversacionales",
    text: "Asistentes entrenados con tu información que atienden a clientes, empleados o ciudadanos las 24 horas, reconocen sus límites, no inventan respuestas y escalan a una persona cuando hace falta.",
    points: ["Respuestas basadas en tus fuentes", "Derivación a personas con contexto", "Integración con web y sistemas internos", "Revisión continua de la calidad"],
  },
  {
    icon: "workflow",
    title: "Automatización de procesos con IA",
    text: "Clasificación de documentos, lectura de facturas y contratos, gestión de correos y flujos administrativos que se ejecutan solos gracias al procesamiento del lenguaje y la visión artificial, y dejan registro auditable.",
    points: ["Extracción de datos de documentos", "Clasificación de correos e incidencias", "Flujos con validación humana", "Trazabilidad de cada paso"],
  },
  {
    icon: "graduation",
    title: "Formación en inteligencia artificial",
    text: "Programas prácticos para plantillas y directivos: del uso responsable de asistentes y la creación de prompts a los fundamentos de datos, Machine Learning e IA responsable para equipos técnicos.",
    points: ["Uso responsable de la IA generativa", "Fundamentos de datos y modelos", "Ética, sesgos y AI Act", "Alfabetización en IA exigida por el AI Act"],
  },
  {
    icon: "shield",
    title: "IA segura y gobierno del dato",
    text: "Evaluación de riesgos e impacto, cumplimiento del AI Act y RGPD, análisis de sesgos, documentación de datos y modelos, control de fugas de información y políticas de uso aceptable de la IA.",
    points: ["Evaluación de impacto previa al despliegue", "Análisis de sesgos por grupos", "Documentación de datasets y modelos", "Supervisión humana y vías de reclamación"],
  },
  {
    icon: "activity",
    title: "Ciberseguridad y SOC 24/7",
    text: "La base sobre la que se apoya toda IA: auditoría, protección de los servicios que exponen modelos, monitorización continua y respuesta a incidentes para proteger datos y modelos.",
    points: ["Auditoría y pentesting", "Protección de APIs y endpoints de modelos", "Monitorización continua", "Respuesta a incidentes"],
  },
];

export const COMPLIANCE_ITEMS = [
  {
    code: "AI Act",
    slug: "ai-act",
    title: "Reglamento europeo de IA",
    text: "Clasificamos tus sistemas por nivel de riesgo, documentamos su funcionamiento y aplicamos las obligaciones de transparencia y supervisión humana exigidas.",
  },
  {
    code: "RGPD",
    slug: "rgpd",
    title: "Protección de datos y AEPD",
    text: "La IA trata datos personales: evaluaciones de impacto, base jurídica clara, brechas notificadas en 72 horas y medidas proporcionadas al riesgo.",
  },
  {
    code: "ENS",
    slug: "ens",
    title: "Esquema Nacional de Seguridad",
    text: "Marco obligatorio para el sector público y sus proveedores. Preparamos la documentación, los controles y la evidencia para la certificación.",
  },
  {
    code: "NIS2",
    slug: "nis2",
    title: "Directiva europea de ciberseguridad",
    text: "Identificamos si tu organización está dentro del ámbito y desplegamos las medidas de gestión de riesgo y notificación exigidas.",
  },
];

export const COMPLIANCE_DETAILS = {
  "ai-act": {
    code: "AI Act",
    eyebrow: "Reglamento europeo de inteligencia artificial",
    title: "Gobierna la IA antes de que se convierta en riesgo",
    intro: "Te ayudamos a saber qué sistemas de IA utilizas, qué nivel de riesgo tienen y qué evidencias necesitas para desplegarlos con transparencia, supervisión humana y control.",
    description: "El AI Act no se resuelve con una política genérica. Requiere entender el contexto de cada sistema, el propósito para el que se utiliza y las personas que pueden verse afectadas. Convertimos esa complejidad en un plan de acción comprensible para dirección, equipos técnicos y usuarios.",
    focus: "Clasificación de riesgo y gobierno de sistemas de IA",
    outcomes: [
      "Inventario de sistemas, proveedores y casos de uso de IA.",
      "Clasificación de cada caso según su nivel de riesgo y obligaciones aplicables.",
      "Políticas de uso responsable, transparencia y supervisión humana.",
      "Evidencias de evaluación, formación, monitorización y mejora continua."
    ],
    deliverables: ["Inventario y mapa de riesgos", "Matriz de obligaciones", "Política de IA responsable", "Expediente de evidencias y revisión"],
    extra: {
      kicker: "IA responsable",
      title: "Del principio ético a la práctica verificable",
      intro: "El AI Act exige que las personas puedan confiar en los sistemas de IA. Eso no se consigue con una declaración de valores, sino con medidas concretas aplicadas a lo largo de todo el ciclo de vida del sistema.",
      items: [
        ["Evaluación de impacto previa", "Antes de desplegar, se analizan los efectos que el sistema puede tener sobre las personas y se decide si procede, con qué límites o si no debe desplegarse."],
        ["Análisis de sesgos por grupos", "Se revisa si el modelo funciona peor para determinados perfiles y si alguna variable actúa como indicador indirecto de factores sensibles."],
        ["Documentación de datos y modelos", "Qué datos se usaron, con qué finalidad, qué transformaciones, qué métricas, qué limitaciones y qué usos no son adecuados."],
        ["Explicabilidad proporcional", "Modelos interpretables cuando el impacto lo exige y técnicas como SHAP o LIME para justificar resultados de modelos complejos."],
        ["Supervisión humana y reclamación", "La IA apoya, prioriza o alerta, pero en decisiones relevantes revisa una persona y el afectado puede pedir revisión."],
        ["Monitorización y retirada", "Seguimiento de rendimiento, sesgos e incidencias tras el despliegue, con la decisión prevista de corregir o retirar el sistema si causa daño."],
      ],
    },
    cta: "Revisar mi gobierno de IA"
  },
  rgpd: {
    code: "RGPD",
    eyebrow: "Protección de datos y relación con la AEPD",
    title: "Usa datos para innovar sin perder el control",
    intro: "Diseñamos el uso de IA alrededor de una base jurídica clara, minimización de datos y medidas proporcionales al riesgo para que la innovación sea defendible.",
    description: "Analizamos qué datos entran en cada modelo, quién los trata, dónde se almacenan y durante cuánto tiempo. Cuando el tratamiento puede implicar un riesgo alto, preparamos la evaluación de impacto y las medidas necesarias para demostrar que la privacidad se ha tenido en cuenta desde el diseño.",
    focus: "Privacidad desde el diseño para datos y modelos",
    outcomes: [
      "Mapa de tratamientos, datos personales y encargados del tratamiento.",
      "Base jurídica, información a las personas y criterios de minimización.",
      "Evaluación de impacto de protección de datos cuando proceda.",
      "Protocolo de brechas, derechos, conservación y revisión de proveedores."
    ],
    deliverables: ["Registro de tratamientos actualizado", "Análisis de legitimación", "EIPD y plan de mitigación", "Protocolo de brechas y evidencias"],
    extra: {
      kicker: "Ciclo de vida de los datos",
      title: "Cada fase del dato tiene su riesgo",
      intro: "Un proyecto de IA no empieza al entrenar el modelo, sino al decidir qué datos se recogen, de dónde proceden y quién aparece en ellos. Si falla un eslabón de la cadena, falla el resultado.",
      items: [
        ["Recogida", "Fuentes fiables, consentimiento cuando es necesario y ningún dato sensible sin una justificación clara."],
        ["Almacenamiento", "Seguridad, permisos de acceso, trazabilidad y plazos de conservación: guardar datos «por si algún día sirven» solo acumula riesgo."],
        ["Preparación", "Eliminar registros, imputar valores o agrupar categorías son decisiones delicadas: una limpieza mal planteada puede reforzar sesgos."],
        ["Entrenamiento", "Si los datos históricos contienen desigualdades, el modelo las reproduce. Se revisa la representatividad antes de entrenar."],
        ["Uso y despliegue", "Quién supervisa, cómo se explica el resultado, cómo se reclama, qué pasa si el modelo falla y cada cuánto se revisa."],
        ["Privacidad desde el diseño", "Minimización, anonimización o seudonimización, cifrado, control de proveedores externos y plazos definidos."],
      ],
    },
    cta: "Evaluar la privacidad de mi IA"
  },
  ens: {
    code: "ENS",
    eyebrow: "Esquema Nacional de Seguridad",
    title: "Prepara una seguridad que se pueda acreditar",
    intro: "Acompañamos a administraciones y proveedores del sector público desde el análisis de situación hasta la preparación de controles, documentación y evidencias para la conformidad ENS.",
    description: "El ENS conecta gobierno, organización y tecnología. Ordenamos el sistema de información, su categoría y sus responsables; después traducimos los principios y requisitos en controles operables, medibles y mantenibles por el equipo.",
    focus: "Seguridad verificable para el sector público y sus proveedores",
    outcomes: [
      "Determinación del alcance, categoría y declaración de aplicabilidad.",
      "Análisis de riesgos y plan de adecuación priorizado.",
      "Políticas, procedimientos, roles y controles técnicos documentados.",
      "Preparación de auditoría, seguimiento de no conformidades y mejora."
    ],
    deliverables: ["Análisis de brecha ENS", "Plan de adecuación por prioridades", "Políticas y procedimientos", "Carpeta de evidencias para auditoría"],
    extra: {
      kicker: "Modelos de IA en el sector público",
      title: "Un modelo publicado es un servicio que proteger",
      intro: "Cuando un modelo se ofrece mediante una API, recibe datos y condiciona decisiones. Para el ENS forma parte del sistema de información y debe protegerse como cualquier otro servicio.",
      items: [
        ["Control de acceso", "Permisos e identidad para cada sistema o persona que consulta el modelo."],
        ["Comunicaciones cifradas", "Toda petición y respuesta viaja cifrada entre el servicio y quien lo consume."],
        ["Validación de entradas", "Los valores fuera de rango o manipulados se rechazan antes de llegar al modelo."],
        ["Registros sin datos sensibles", "Se registran errores y uso sin exponer información personal en logs ni mensajes de depuración."],
        ["Versionado y aprobación", "Ningún modelo pasa del experimento a producción: se valida, registra, aprueba y despliega en entorno controlado."],
        ["Monitorización y retirada", "Uso, latencia, errores y calidad de las predicciones vigilados, con plan de actualización o retirada."],
      ],
    },
    cta: "Preparar mi adecuación ENS"
  },
  nis2: {
    code: "NIS2",
    eyebrow: "Directiva europea de ciberseguridad",
    title: "Convierte la ciberseguridad en resiliencia operativa",
    intro: "Determinamos si tu organización entra en el ámbito de NIS2 y construimos un programa de gestión de riesgos, respuesta y notificación que pueda sostenerse en el tiempo.",
    description: "NIS2 afecta a la dirección y a la operación diaria, no solo al departamento de tecnología. Revisamos gobierno, cadena de suministro, continuidad, gestión de vulnerabilidades y respuesta ante incidentes para que las obligaciones se traduzcan en decisiones y controles reales.",
    focus: "Gestión de riesgos, continuidad y respuesta ante incidentes",
    outcomes: [
      "Análisis de aplicabilidad, sector, tamaño y servicios esenciales.",
      "Evaluación de riesgos y dependencias de la cadena de suministro.",
      "Medidas de prevención, continuidad, cifrado, accesos y vulnerabilidades.",
      "Plan de respuesta, comunicación y evidencias de ejercicios periódicos."
    ],
    deliverables: ["Informe de aplicabilidad", "Mapa de riesgos y dependencias", "Plan de medidas prioritarias", "Playbooks y registro de incidentes"],
    extra: {
      kicker: "IA y gestión del riesgo",
      title: "La IA como aliada y como superficie de ataque",
      intro: "NIS2 pide gestionar el riesgo de todos los sistemas, y los modelos de IA son ya uno más. A la vez, la propia IA es una de las mejores herramientas para detectar amenazas.",
      items: [
        ["Detección de anomalías", "Modelos que señalan comportamientos que se salen del patrón habitual en redes, accesos o transacciones."],
        ["Priorización de alertas", "Clasificación automática de eventos para que el equipo se centre en lo que realmente importa."],
        ["Inventario de modelos y proveedores", "Qué modelos y servicios de IA externos se usan, qué datos reciben y qué dependencia generan en la cadena de suministro."],
        ["Endpoints protegidos", "APIs de modelos con identidad, cifrado, validación de entradas y monitorización de uso indebido."],
        ["Vigilancia del rendimiento", "Un modelo que pierde calidad sin que nadie lo note es también un riesgo operativo."],
        ["Respuesta a incidentes", "Los fallos y usos indebidos de la IA se incluyen en el plan de incidentes y en la notificación cuando proceda."],
      ],
    },
    cta: "Comprobar mi situación NIS2"
  }
};

export const COMPLIANCE_LEGAL_CONTENT = {
  "ai-act": {
    what: "El Reglamento (UE) 2024/1689, conocido como AI Act, es la norma europea que establece reglas armonizadas para comercializar, poner en servicio y utilizar sistemas y modelos de inteligencia artificial. Su objetivo es proteger la salud, la seguridad y los derechos fundamentales, y fomentar una IA fiable.",
    who: "Afecta a proveedores que desarrollan o comercializan IA, a quienes despliegan sistemas en su organización, a importadores, distribuidores y, en determinados casos, a entidades situadas fuera de la Unión cuando el resultado del sistema se utiliza en la UE.",
    rules: [
      ["Prácticas prohibidas", "Algunos usos considerados inaceptables quedan prohibidos, como determinadas técnicas manipuladoras, la explotación de vulnerabilidades o ciertos sistemas de puntuación social."],
      ["Alto riesgo", "Los sistemas incluidos en los ámbitos de alto riesgo deben cumplir requisitos de gestión de riesgos, datos y gobernanza, documentación técnica, registros, transparencia, supervisión humana, precisión, robustez y ciberseguridad."],
      ["Transparencia", "Las personas deben saber cuándo interactúan con una máquina en los casos previstos y determinados contenidos generados o manipulados por IA deben identificarse de forma adecuada."],
      ["Responsabilidad continua", "El cumplimiento no termina al desplegar el sistema: hay que monitorizarlo, registrar incidentes, corregir desviaciones y conservar la documentación necesaria."],
    ],
    timeline: "El Reglamento se aplica de forma progresiva. Las prohibiciones y las obligaciones de alfabetización en IA comenzaron a aplicarse el 2 de febrero de 2025; las obligaciones para modelos de uso general, el 2 de agosto de 2025, y la aplicación general está prevista para el 2 de agosto de 2026, con excepciones y periodos específicos según el tipo de sistema.",
    source: "https://eur-lex.europa.eu/legal-content/ES/TXT/?uri=CELEX:32024R1689",
    sourceLabel: "Texto oficial del Reglamento de IA en EUR-Lex"
  },
  rgpd: {
    what: "El Reglamento (UE) 2016/679 (RGPD) regula el tratamiento de datos personales. En un proyecto de IA se aplica cuando los datos permiten identificar, directa o indirectamente, a una persona: desde los datos usados para entrenar o probar un modelo hasta las consultas, registros y resultados que genera.",
    who: "Obliga a responsables y encargados del tratamiento, incluidos proveedores de nube, plataformas de IA y consultoras que traten datos por cuenta de otra organización. La AEPD es la autoridad de control en España, sin perjuicio de otras autoridades europeas cuando el tratamiento sea transfronterizo.",
    rules: [
      ["Principios", "Legalidad, lealtad y transparencia; limitación de la finalidad; minimización; exactitud; limitación del plazo de conservación; integridad, confidencialidad y responsabilidad proactiva."],
      ["Base jurídica e información", "Cada tratamiento necesita una base jurídica y las personas deben recibir información clara sobre qué datos se usan, para qué, durante cuánto tiempo y qué derechos pueden ejercer."],
      ["Riesgo y privacidad desde el diseño", "Cuando el tratamiento pueda entrañar un riesgo alto, debe realizarse una evaluación de impacto. La organización debe aplicar medidas técnicas y organizativas adecuadas y demostrar que las ha elegido de forma razonada."],
      ["Derechos y brechas", "Hay que poder atender acceso, rectificación, supresión, oposición, limitación y portabilidad cuando proceda. Una brecha con riesgo debe notificarse a la autoridad de control sin dilación indebida y, como regla general, dentro de 72 horas desde que se tiene constancia."],
    ],
    timeline: "El RGPD es aplicable desde el 25 de mayo de 2018. En España se complementa con la Ley Orgánica 3/2018 y con las guías, resoluciones y criterios publicados por la AEPD.",
    source: "https://eur-lex.europa.eu/eli/reg/2016/679/oj?locale=es",
    sourceLabel: "Texto oficial del RGPD en EUR-Lex"
  },
  ens: {
    what: "El Esquema Nacional de Seguridad, regulado por el Real Decreto 311/2022, establece los principios y requisitos para proteger la información y los servicios de las administraciones públicas y de los proveedores que trabajan con ellas. No es solo una certificación: es un sistema de gestión de la seguridad basado en el riesgo.",
    who: "Se aplica al sector público y a los sistemas de información de entidades privadas que prestan servicios o proveen soluciones a las entidades públicas cuando el contrato o la normativa lo exige. El alcance concreto se determina sistema por sistema.",
    rules: [
      ["Responsabilidad y gobierno", "La organización debe definir la política de seguridad, responsables, funciones, normas y procedimientos. La seguridad debe contar con respaldo de la dirección y estar integrada en la gestión."],
      ["Análisis y categoría", "Se identifican activos, servicios, dependencias y riesgos, y se determina una categoría —básica, media o alta— atendiendo a la posible repercusión sobre confidencialidad, integridad, disponibilidad, autenticidad y trazabilidad."],
      ["Medidas de seguridad", "El anexo II reúne medidas organizativas, operacionales y de protección: control de accesos, gestión de incidentes, continuidad, registros, configuración, proveedores, protección de comunicaciones y seguridad física, entre otras."],
      ["Conformidad", "La organización debe conservar evidencias y someterse a los mecanismos de verificación que correspondan. La conformidad se mantiene con revisiones, auditorías, gestión de riesgos y corrección de desviaciones."],
    ],
    timeline: "El marco vigente en España es el Real Decreto 311/2022, de 3 de mayo. Sus requisitos deben interpretarse junto con las instrucciones técnicas de seguridad y las guías CCN-STIC aplicables al sistema.",
    source: "https://www.boe.es/buscar/act.php?id=BOE-A-2022-7191",
    sourceLabel: "Real Decreto 311/2022 en el BOE"
  },
  nis2: {
    what: "La Directiva (UE) 2022/2555, conocida como NIS2, eleva el nivel común de ciberseguridad en la Unión Europea. Amplía los sectores cubiertos, refuerza la responsabilidad de la dirección, exige medidas de gestión de riesgos y establece obligaciones de notificación y supervisión.",
    who: "Incluye entidades esenciales e importantes de sectores como energía, transporte, banca, salud, agua, infraestructura digital, administración pública, servicios postales, fabricación crítica y otros servicios digitales. La inclusión depende del sector, tamaño, actividad y reglas nacionales de transposición.",
    rules: [
      ["Gestión del riesgo", "Las entidades deben adoptar medidas técnicas, operativas y organizativas proporcionadas: análisis de riesgos, gestión de incidentes, continuidad y recuperación, crisis, seguridad de proveedores, vulnerabilidades, cifrado y autenticación multifactor."],
      ["Responsabilidad directiva", "Los órganos de dirección deben aprobar y supervisar las medidas de ciberseguridad, recibir formación y pueden quedar sujetos a responsabilidades conforme al marco nacional."],
      ["Notificación de incidentes", "Los incidentes significativos deben comunicarse a las autoridades o al CSIRT competente siguiendo el esquema y los plazos que resulten aplicables en la transposición nacional."],
      ["Supervisión y sanciones", "Las autoridades pueden requerir información, realizar inspecciones y ordenar medidas correctoras. El régimen distingue entre entidades esenciales e importantes, sin eliminar la obligación de gestionar el riesgo."],
    ],
    timeline: "La Directiva debía transponerse antes del 17 de octubre de 2024. En España, el análisis de aplicabilidad debe contrastarse con la normativa nacional vigente, el sector concreto y las instrucciones de la autoridad competente.",
    source: "https://eur-lex.europa.eu/legal-content/ES/TXT/?uri=CELEX:32022L2555",
    sourceLabel: "Texto oficial de NIS2 en EUR-Lex"
  }
};

export const INCIDENT_STEPS = [
  {
    step: "01",
    title: "Identificación y contención",
    text: "Detecta el alcance real del incidente y aísla los sistemas afectados sin apagarlos: la memoria volátil contiene evidencias clave. Desconecta de la red, no de la corriente.",
  },
  {
    step: "02",
    title: "Análisis y preservación de evidencias",
    text: "Documenta todo: capturas, registros, horas y acciones realizadas. Una cadena de custodia correcta convierte tu investigación en una prueba válida ante un procedimiento legal.",
  },
  {
    step: "03",
    title: "Notificación legal",
    text: "Si hay datos personales afectados, el RGPD exige notificar a la AEPD en un máximo de 72 horas. En sectores regulados pueden aplicar plazos adicionales de NIS2 o DORA.",
  },
  {
    step: "04",
    title: "Recuperación y lecciones aprendidas",
    text: "Restaura desde copias verificadas, corrige la causa raíz y actualiza tus controles. Cada incidente bien gestionado fortalece la organización que lo supera.",
  },
];

export const ECOSYSTEM = [
  { name: "Aula Virtual", tag: "Formación", text: "Entorno de cursos, materiales y seguimiento formativo para equipos y centros." },
  { name: "Signados", tag: "Seguridad", text: "Firma digital y certificación segura de documentos con validez probatoria." },
  { name: "Markitplace", tag: "Comunicación e IA", text: "Soluciones de comunicación y generación de contenidos asistida por IA." },
  { name: "Consulting", tag: "Transformación", text: "Automatización e inteligencia artificial aplicadas a procesos reales de negocio." },
  { name: "Turismo", tag: "Turismo · IA", text: "Promoción turística digital con mapas interactivos y asistente inteligente." },
  { name: "Chatbot conversacional", tag: "Comunicación · IA", text: "Asistente que atiende consultas y facilita el acceso a la información." },
];

export const CERTS = ["AI Act", "RGPD", "ENS", "ISO/IEC 27001", "NIS2", "INCIBE"];

export const PILLARS = [
  {
    title: "Primero el problema, después la tecnología",
    text: "La pregunta no es qué tecnología es más avanzada, sino qué problema quieres resolver y con qué datos cuentas. Si una regla de negocio o un análisis estadístico lo resuelve con menos coste, te lo diremos.",
  },
  {
    title: "IA con retorno real",
    text: "Cada proyecto parte de un caso de uso medible, con los costes de desarrollo y operación estimados frente al valor esperado, y termina con métricas que demuestran el ahorro o la mejora conseguida.",
  },
  {
    title: "Seguridad y ética desde el diseño",
    text: "Cada agente, modelo o automatización nace con gobierno del dato, análisis de sesgos, explicabilidad, control de accesos y supervisión humana integrados, no añadidos después.",
  },
  {
    title: "Cercanía y respuesta inmediata",
    text: "Cuando ocurre un incidente, hablas con personas que conocen tu entorno. Sin centralitas ni tickets perdidos: respuesta directa en minutos.",
  },
];

export const SERVICE_OPTIONS = [
  "Consultoría e implantación de IA",
  "Analítica de datos y modelos predictivos",
  "Agentes y chatbots conversacionales",
  "Automatización de procesos con IA",
  "Formación en inteligencia artificial",
  "IA segura y gobierno del dato",
  "Ciberseguridad y SOC 24/7",
  "He sufrido un ciberataque",
  "Otro",
];

export const RISK_QUESTIONS = [
  {
    q: "¿Tu organización ya utiliza herramientas de IA en el día a día?",
    options: [
      { label: "Sí, con políticas y controles definidos", points: 0 },
      { label: "Sí, pero cada uno usa lo que quiere", points: 1 },
      { label: "No las usamos o no lo sé", points: 2 },
    ],
  },
  {
    q: "¿Sabes qué datos internos pueden llegar a herramientas de IA externas?",
    options: [
      { label: "Sí, hay un inventario y reglas claras", points: 0 },
      { label: "Más o menos, sin documentar", points: 1 },
      { label: "No lo controlamos", points: 2 },
    ],
  },
  {
    q: "¿Tu plantilla ha recibido formación en uso responsable de la IA?",
    options: [
      { label: "Sí, al menos una vez al año", points: 0 },
      { label: "Solo charlas puntuales", points: 1 },
      { label: "Nunca o casi nunca", points: 2 },
    ],
  },
  {
    q: "¿Disponéis de copias de seguridad probadas y autenticación multifactor?",
    options: [
      { label: "Sí, ambas verificadas", points: 0 },
      { label: "Solo una de las dos", points: 1 },
      { label: "Ninguna o no lo sé", points: 2 },
    ],
  },
  {
    q: "¿Tu sector está sujeto a obligaciones como AI Act, NIS2, ENS o RGPD reforzado?",
    options: [
      { label: "No", points: 0 },
      { label: "No lo sé con seguridad", points: 1 },
      { label: "Sí", points: 2 },
    ],
  },
];

export const RISK_RESULTS = {
  low: {
    label: "Riesgo controlado",
    color: "#06D6A0",
    service: "Formación en inteligencia artificial",
    text: "Tu organización aplica los controles esenciales. El siguiente paso es mantener el nivel: la tecnología evoluciona cada trimestre y la formación continua evita que las buenas prácticas se degraden con el tiempo.",
  },
  mid: {
    label: "Riesgo moderado",
    color: "#3FE0F2",
    service: "Consultoría e implantación de IA",
    text: "Usáis IA, pero sin un marco claro: ahí es donde se producen las fugas de datos y los usos fuera de norma. Una consultoría te dará el mapa: qué usos son seguros, cuáles hay que corregir y dónde está el retorno real.",
  },
  high: {
    label: "Riesgo elevado",
    color: "#FF6B6B",
    service: "Ciberseguridad y SOC 24/7",
    text: "Tu perfil combina exposición alta y controles débiles: el escenario favorito de los ataques oportunistas y de las fugas hacia herramientas externas. Recomendamos reforzar la base de seguridad y vigilar de forma continua antes de seguir escalando IA.",
  },
};

export const CASE_STUDIES = [
  {
    name: "Aula Virtual Cibermedida",
    slug: "aula-virtual-cibermedida",
    sector: "Formación",
    image: "https://images.unsplash.com/photo-1549605659-32d82da3a059?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxjeWJlciUyMHNlY3VyaXR5JTIwaGFja2VyJTIwY29kZSUyMHNjcmVlbiUyMGRhcmslMjBwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwdGVjaHxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
    challenge: "Centros formativos y empresas necesitaban impartir cursos técnicos con seguimiento real del alumnado, sin depender de plataformas genéricas que no se adaptan a sus contenidos ni a sus procesos.",
    solution: "Diseñamos y operamos un aula virtual propia con cursos, materiales, evaluaciones y panel de seguimiento, integrada con la identidad y los contenidos de cada organización.",
    result: "Formación continua en marcha con seguimiento por alumno y contenidos actualizables por el propio centro, sin costes de licencia por cambio.",
    stack: ["Plataforma propia", "SCORM", "Seguimiento formativo"],
  },
  {
    name: "Chatbot conversacional",
    slug: "chatbot-conversacional",
    sector: "Comunicación · IA",
    image: "https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxjeWJlciUyMHNlY3VyaXR5JTIwaGFja2VyJTIwY29kZSUyMHNjcmVlbiUyMGRhcmslMjBwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwdGVjaHxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
    challenge: "Las mismas preguntas repetidas consumían horas del equipo cada semana, y fuera del horario nadie atendía a los visitantes de la web.",
    solution: "Implantamos un asistente conversacional entrenado con la información de la organización, con respuestas inmediatas y derivación a personas cuando el tema lo requiere.",
    result: "Atención disponible 24/7 y un equipo liberado de las consultas repetitivas para centrarse en las que sí aportan valor.",
    stack: ["IA conversacional", "Integración web", "Escalado humano"],
  },
  {
    name: "Signados",
    slug: "signados",
    sector: "Seguridad",
    image: "https://images.unsplash.com/photo-1639066648921-82d4500abf1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMHNlcnZlciUyMHJvb20lMjBkYXJrJTIwbmVvbiUyMGN5YW4lMjBzaGllbGQlMjBkYXRhJTIwZGVmZW5zZXxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
    challenge: "Contratos y documentos sensibles circulaban por correo sin garantía de quién los firmaba ni de que no hubieran sido alterados después.",
    solution: "Creamos Signados, una plataforma de firma digital y certificación segura que aporta validez probatoria a cada documento.",
    result: "Documentos certificados con evidencia de firma e integridad, listos para tener valor ante cualquier requerimiento.",
    stack: ["Firma digital", "Certificación", "Trazabilidad"],
  },
  {
    name: "Turismo Cibermedida",
    slug: "turismo-cibermedida",
    sector: "Turismo · IA",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMHNlcnZlciUyMHJvb20lMjBkYXJrJTIwbmVvbiUyMGN5YW4lMjBzaGllbGQlMjBkYXRhJTIwZGVmZW5zZXxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
    challenge: "Destinos y negocios turísticos necesitaban ofrecer información útil al visitante sin mantener un equipo contestando las mismas dudas de siempre.",
    solution: "Desarrollamos una plataforma de promoción turística con mapas interactivos y un asistente inteligente que guía al visitante en tiempo real.",
    result: "Visitantes mejor informados y una imagen de destino moderna, con contenido gestionable por el propio equipo de turismo.",
    stack: ["Mapas interactivos", "Asistente IA", "Gestión de contenidos"],
  },
  {
    name: "Markitplace",
    slug: "markitplace",
    sector: "Comunicación · IA",
    image: "https://images.unsplash.com/photo-1680992046615-065f58bcb4d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHw0fHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMHNlcnZlciUyMHJvb20lMjBkYXJrJTIwbmVvbiUyMGN5YW4lMjBzaGllbGQlMjBkYXRhJTIwZGVmZW5zZXxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
    challenge: "Mantener una comunicación activa (noticias, redes, materiales) exigía unas horas que los equipos pequeños simplemente no tienen.",
    solution: "Construimos Markitplace, una solución de generación de contenidos con IA que produce borradores alineados con el tono de cada organización para revisión humana.",
    result: "Comunicación constante con supervisión humana: la IA propone y el equipo decide, en una fracción del tiempo anterior.",
    stack: ["IA generativa", "Flujo de aprobación", "Multicanal"],
  },
  {
    name: "Ikas Txiki — Fútbol Base",
    slug: "ikas-txiki-futbol-base",
    sector: "Gestión deportiva",
    image: "https://images.unsplash.com/photo-1549605659-32d82da3a059?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxjeWJlciUyMHNlY3VyaXR5JTIwaGFja2VyJTIwY29kZSUyMHNjcmVlbiUyMGRhcmslMjBwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwdGVjaHxlbnwwfHx8fDE3OTMxNzE2MjR8MA&ixlib=rb-4.1.0&q=85",
    challenge: "Un club de fútbol base gestionaba equipos, convocatorias y comunicaciones con familias por hojas de cálculo y grupos de mensajería.",
    solution: "Digitalizamos la organización completa de la actividad: equipos, calendarios, convocatorias y avisos centralizados en una sola plataforma.",
    result: "Menos coordinación manual, familias informadas al momento y toda la actividad del club ordenada en un único lugar.",
    stack: ["Gestión deportiva", "Notificaciones", "Calendarios"],
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Descubrimiento",
    text: "Distinguimos el problema percibido («queremos un chatbot») del problema real («queremos reducir el tiempo de respuesta»). Analizamos datos disponibles, coste de cada tipo de error, necesidad de explicación, marco legal, madurez de la organización y retorno esperado, con una estimación honesta de esfuerzo e impacto.",
  },
  {
    step: "02",
    title: "Diseño y prueba de concepto",
    text: "Comparamos alternativas con criterios explícitos (coste, rendimiento, explicabilidad, mantenimiento) y validamos lo más incierto con una prueba de concepto acotada. Su resultado no es un sistema, sino una decisión informada: continuar, redefinir o abandonar.",
  },
  {
    step: "03",
    title: "Implantación",
    text: "Desarrollamos por iteraciones: comprensión del negocio y de los datos, preparación, modelado, evaluación y despliegue, con entregas parciales que puedes probar. Tu equipo participa desde el primer sprint, no en la presentación final.",
  },
  {
    step: "04",
    title: "Acompañamiento",
    text: "Un modelo no queda terminado al desplegarse: los datos y los comportamientos cambian. Monitorizamos rendimiento, sesgos y errores, reentrenamos cuando hace falta y formamos a las personas que lo usan. El proyecto termina cuando funciona.",
  },
];

export const HOME_FEATURES = [
  {
    image: "code",
    kicker: "Agentes",
    title: "Agentes que trabajan mientras tu equipo descansa",
    text: "Un agente conversacional bien diseñado atiende consultas, clasifica solicitudes y prepara respuestas a cualquier hora. No basta con que hable con fluidez: tiene que entender el contexto, reconocer sus límites y no inventar. No sustituye a tu equipo: le devuelve las horas que hoy se van en tareas repetitivas.",
    points: ["Atención ininterrumpida sin ampliar plantilla", "Respuestas basadas en tu información real", "Escalado a personas con contexto completo"],
  },
  {
    image: "analyst",
    kicker: "Datos",
    title: "Tus datos, por fin hablando claro",
    text: "La mayoría de organizaciones guardan años de información que nadie consulta. Tras limpiarla y prepararla (una fase que suele llevar más tiempo que el propio modelo), la analítica con IA detecta patrones, anticipa demanda y señala anomalías antes de que se conviertan en problemas, presentada en paneles que cualquier directivo entiende.",
    points: ["Detección de anomalías en tiempo real", "Previsión de demanda y comportamiento", "Paneles comprensibles sin conocimientos técnicos"],
  },
  {
    image: "serverRack",
    kicker: "Seguridad",
    title: "La seguridad como cimiento de toda IA",
    text: "Un modelo expuesto como servicio recibe datos sensibles e influye en decisiones reales. Por eso ningún proyecto sale de Cibermedida sin control de accesos, cifrado, validación de entradas, versiones controladas y vigilancia continua: innovar deprisa solo funciona cuando la base está protegida.",
    points: ["Gobierno del dato y cumplimiento del AI Act", "Monitorización 24/7 de sistemas y modelos", "Evidencias auditables de cada control"],
  },
];

export const FAQ_ITEMS = [
  {
    q: "¿Necesito conocimientos técnicos para implantar IA en mi empresa?",
    a: "No. Nuestro trabajo es precisamente traducir la tecnología a tu operativa diaria: tú aportas el conocimiento de tu negocio y nosotros nos encargamos de la parte técnica, la formación de tu equipo y el mantenimiento.",
  },
  {
    q: "¿Qué diferencia hay entre IA, Machine Learning y Deep Learning?",
    a: "La inteligencia artificial es el campo completo. El Machine Learning es la parte que aprende patrones a partir de datos en lugar de seguir reglas escritas a mano. El Deep Learning es un tipo de Machine Learning basado en redes neuronales de muchas capas, especialmente útil con imágenes, audio y texto.",
  },
  {
    q: "¿Necesito tener muchos datos para empezar?",
    a: "Depende del problema. Algunos modelos funcionan bien con conjuntos pequeños y bien preparados; las redes neuronales necesitan muchos más. Importa más la calidad que la cantidad: datos representativos, actualizados y sin errores. Si no hay datos suficientes, te lo diremos y te ayudaremos a recogerlos antes de construir nada.",
  },
  {
    q: "¿Toda empresa necesita inteligencia artificial?",
    a: "No siempre. A veces una regla de negocio, una automatización sencilla o un análisis estadístico resuelven el problema con menos coste y más fácil mantenimiento. La IA es una herramienta, no un fin: en la fase de descubrimiento decidimos contigo si tiene sentido aplicarla.",
  },
  {
    q: "¿Cuánto tarda un primer proyecto de inteligencia artificial?",
    a: "Depende del alcance, y por eso nunca prometemos plazos sin conocer el caso. En la fase de descubrimiento analizamos tu situación y te entregamos una estimación honesta de tiempos, costes e impacto. Cuando hay dudas técnicas, empezamos con una prueba de concepto acotada antes de comprometer más inversión.",
  },
  {
    q: "¿La IA puede equivocarse o inventarse respuestas?",
    a: "Sí. Un modelo predictivo da estimaciones, no certezas, y la IA generativa puede producir información incorrecta. Por eso medimos los errores, revisamos el rendimiento de forma periódica y mantenemos supervisión humana en las decisiones que afectan a personas.",
  },
  {
    q: "¿Cómo evitáis que un modelo discrimine o tenga sesgos?",
    a: "Revisando todo el ciclo: la representatividad de los datos, las variables que pueden actuar como indicadores indirectos de factores sensibles y los resultados por grupos, no solo la métrica global. Documentamos el modelo, aplicamos explicabilidad cuando el impacto lo exige y lo vigilamos tras el despliegue.",
  },
  {
    q: "¿La IA que implantáis cumple con el RGPD y el AI Act?",
    a: "Sí. Cada despliegue incluye gobierno del dato, minimización, evaluación de riesgos según el AI Act y medidas de protección conforme al RGPD. Además, documentamos todo para que el cumplimiento sea demostrable ante cualquier auditoría.",
  },
  {
    q: "¿Trabajáis con empresas pequeñas o solo con grandes organizaciones?",
    a: "Trabajamos con empresas, centros formativos y administraciones de cualquier tamaño. El catálogo es modular: puedes empezar con una consultoría puntual o un único agente y crecer cuando veas el retorno.",
  },
  {
    q: "¿Qué hago si creo que he sufrido un ciberataque?",
    a: "No apagues los equipos ni borres nada: la memoria contiene evidencias clave. Usa el botón rojo 'Ataque en curso' o el formulario de contacto indicándolo en el mensaje, y priorizaremos tu solicitud para guiar la contención.",
  },
];

export const LEGAL_PAGES = {
  "aviso-legal": {
    title: "Aviso Legal",
    updated: "Última actualización: julio de 2026",
    blocks: [
      { type: "h3", text: "1. Titular del sitio web" },
      { type: "p", text: "En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de que el titular de este sitio web es Cibermedida (en adelante, «el Titular»), con domicilio en Cantabria, España, y correo electrónico de contacto jfloradmin@cibermedida.es. Los datos registrales y fiscales completos se facilitarán a cualquier usuario que los solicite por escrito." },
      { type: "h3", text: "2. Objeto y aceptación" },
      { type: "p", text: "Este sitio web tiene por objeto dar a conocer los servicios de inteligencia artificial, ciberseguridad, formación y transformación digital ofrecidos por el Titular, así como facilitar el contacto con potenciales clientes. El acceso y uso del sitio atribuye la condición de usuario e implica la aceptación plena de las condiciones recogidas en este aviso legal." },
      { type: "h3", text: "3. Propiedad intelectual e industrial" },
      { type: "p", text: "Todos los contenidos del sitio —textos, logotipos, diseño, código e imágenes— son titularidad del Titular o se utilizan con licencia, y están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o transformación sin autorización expresa y por escrito." },
      { type: "h3", text: "4. Responsabilidad" },
      { type: "p", text: "Los contenidos de divulgación publicados tienen carácter meramente informativo y no constituyen asesoramiento jurídico ni técnico personalizado. El Titular no responde de los daños derivados del uso de la información sin una evaluación profesional del caso concreto, ni del contenido de sitios de terceros enlazados desde esta página." },
      { type: "h3", text: "5. Legislación aplicable" },
      { type: "p", text: "Este aviso legal se rige por la legislación española. Para cualquier controversia derivada del acceso o uso de este sitio web, las partes se someten a los juzgados y tribunales que resulten competentes conforme a derecho." },
    ],
  },
  "politica-privacidad": {
    title: "Política de Privacidad",
    updated: "Última actualización: julio de 2026",
    blocks: [
      { type: "h3", text: "1. Responsable del tratamiento" },
      { type: "p", text: "El responsable del tratamiento de los datos personales recabados a través de este sitio web es Cibermedida, con domicilio en Cantabria, España, y correo electrónico jfloradmin@cibermedida.es. Tratamos tus datos conforme al Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018 (LOPDGDD)." },
      { type: "h3", text: "2. Datos que recogemos y finalidad" },
      { type: "p", text: "A través del formulario de contacto recogemos nombre, empresa, teléfono, correo electrónico y el contenido del mensaje. La finalidad es exclusivamente atender tu solicitud de información, gestionar la relación comercial derivada y, en su caso, coordinar la respuesta ante un incidente de seguridad que nos comuniques. Las conversaciones con el asistente virtual se registran para mejorar el servicio y no se utilizan con fines publicitarios." },
      { type: "h3", text: "3. Base jurídica y conservación" },
      { type: "p", text: "La base del tratamiento es tu consentimiento, expresado al enviar el formulario o al usar el asistente, y la aplicación de medidas precontractuales cuando solicitas un servicio. Conservamos los datos el tiempo necesario para atender tu solicitud y, como máximo, durante los plazos de prescripción legal aplicables si se formaliza una relación contractual." },
      { type: "h3", text: "4. Destinatarios y transferencias" },
      { type: "p", text: "Los datos no se ceden a terceros salvo obligación legal. El envío de comunicaciones por correo electrónico y el asistente virtual se apoyan en proveedores tecnológicos que actúan como encargados del tratamiento con las garantías exigidas por el RGPD." },
      { type: "h3", text: "5. Tus derechos" },
      { type: "p", text: "Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a jfloradmin@cibermedida.es, adjuntando un documento que acredite tu identidad. Si consideras que el tratamiento no se ajusta a la normativa, puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es)." },
      { type: "h3", text: "6. Medidas de seguridad" },
      { type: "p", text: "Aplicamos medidas técnicas y organizativas proporcionadas al riesgo —control de accesos, cifrado en tránsito y minimización de datos— para proteger tu información frente a accesos no autorizados, pérdida o alteración." },
    ],
  },
};

// ——— Conocimiento de IA (página /inteligencia-artificial) ———

export const AI_REALITY = {
  title: "Ni magia ni ciencia ficción",
  text: "Toda IA hace tres cosas: percibe información (un texto, una imagen, una transacción), aprende de ejemplos previos y actúa generando una predicción, una recomendación, una clasificación o una respuesta. La que se usa hoy en empresas es IA «débil» o estrecha: muy potente en tareas concretas, pero dependiente de datos, diseño, entrenamiento, supervisión y límites de uso. La IA «fuerte», con capacidades generales comparables a las humanas, sigue siendo un concepto teórico. Tenerlo claro evita expectativas irreales.",
  steps: [
    ["Percibir", "Recibe datos: un correo, una foto, una lectura de sensor, el historial de un cliente."],
    ["Aprender", "Mejora su comportamiento a partir de ejemplos anteriores en lugar de reglas escritas a mano."],
    ["Actuar", "Predice, recomienda, clasifica, alerta o responde, y una persona decide qué hacer con ello."],
  ],
};

export const LEARNING_TYPES = [
  {
    name: "Supervisado",
    data: "Datos etiquetados: ya se conoce la respuesta correcta",
    goal: "Clasificar casos o predecir valores numéricos",
    example: "Distinguir correos legítimos de fraudulentos tras ver miles ya clasificados, o estimar las ventas del próximo mes.",
  },
  {
    name: "No supervisado",
    data: "Datos sin etiquetas previas",
    goal: "Descubrir grupos, relaciones o anomalías ocultas",
    example: "Segmentar clientes por comportamiento sin definir antes las categorías, o detectar movimientos inusuales en una red.",
  },
  {
    name: "Por refuerzo",
    data: "Interacción con un entorno mediante recompensas y penalizaciones",
    goal: "Aprender la mejor secuencia de decisiones",
    example: "Un robot de almacén que aprende rutas más rápidas evitando obstáculos. La clave está en diseñar bien qué se premia.",
  },
  {
    name: "Semisupervisado",
    data: "Pocos datos etiquetados y muchos sin etiquetar",
    goal: "Aprovechar al máximo un etiquetado caro o escaso",
    example: "Clasificar imágenes cuando solo una pequeña parte ha sido revisada por un especialista.",
  },
];

export const ALGORITHMS = [
  { name: "Reglas y sistemas expertos", family: "IA simbólica", use: "Validaciones y procesos con normas claras: «si ocurre esto, haz aquello».", note: "Totalmente explicable; difícil de mantener si el problema cambia a menudo." },
  { name: "Árboles de decisión", family: "Clasificación", use: "Riesgo de abandono a partir de preguntas sucesivas: uso, reclamaciones, renovaciones.", note: "Muy intuitivo; si crece demasiado se ajusta en exceso a los datos." },
  { name: "Random Forest", family: "Clasificación y regresión", use: "Operaciones sospechosas, bajas de clientes o fallos de maquinaria combinando muchos árboles.", note: "Robusto y preciso; algo menos fácil de interpretar." },
  { name: "Regresión lineal", family: "Regresión", use: "Estimar precios, costes, demanda o tendencias a partir de varias variables.", note: "Rápida e interpretable; limitada si la relación no es lineal." },
  { name: "Regresión logística", family: "Clasificación", use: "Probabilidad de fraude, de compra o de spam: «92 % de probabilidad, a revisión».", note: "Sencilla, rápida y explicable." },
  { name: "K-means", family: "Agrupamiento", use: "Segmentar clientes en frecuentes, ocasionales, sensibles a descuentos o premium.", note: "Hay que indicar de antemano cuántos grupos se buscan." },
  { name: "KNN", family: "Clasificación", use: "Clasificar un caso nuevo comparándolo con los más parecidos que ya existen.", note: "Fácil de entender; lento con grandes volúmenes." },
  { name: "SVM", family: "Clasificación", use: "Documentos, imágenes con defectos o perfiles de riesgo separados por una frontera de máximo margen.", note: "Muy sólido con conjuntos medianos y bien preparados." },
  { name: "Naive Bayes", family: "Texto", use: "Detección de spam, clasificación de opiniones y categorización de documentos.", note: "Rápido y eficaz en problemas de lenguaje." },
  { name: "Redes convolucionales (CNN)", family: "Visión artificial", use: "Matrículas, señales, radiografías o defectos en una línea de fabricación.", note: "Aprenden bordes, texturas y objetos de forma progresiva." },
  { name: "Redes recurrentes (RNN)", family: "Secuencias", use: "Series temporales: consumo energético o señales de sensores industriales.", note: "Tienen memoria del orden de los datos." },
  { name: "Transformadores", family: "Lenguaje e IA generativa", use: "Resumir, traducir, responder y generar texto o código con mecanismos de atención.", note: "La base de los asistentes actuales; exigen muchos datos y cálculo." },
  { name: "Detección de anomalías", family: "Monitorización", use: "Compras desde un país y horario inusuales o una máquina que empieza a vibrar distinto.", note: "Clave en ciberseguridad, banca y mantenimiento." },
  { name: "Algoritmos genéticos", family: "Optimización", use: "Rutas de reparto, horarios y planificación con millones de combinaciones posibles.", note: "Mejoran soluciones por selección, cruce y mutación." },
];

export const AI_CHOICE = [
  ["Aplicar normas claras y estables", "Reglas o sistemas expertos"],
  ["Predecir un valor o clasificar casos con datos históricos", "Machine Learning supervisado"],
  ["Encontrar grupos o patrones ocultos", "Aprendizaje no supervisado"],
  ["Analizar imágenes o vídeo", "Visión artificial y redes neuronales"],
  ["Procesar textos o conversaciones", "Procesamiento del lenguaje natural"],
  ["Crear contenido o borradores", "IA generativa, siempre con revisión"],
  ["Detectar lo que se sale de lo normal", "Detección de anomalías"],
  ["Optimizar rutas, horarios o recursos", "Optimización y aprendizaje por refuerzo"],
];

export const AI_CHOICE_QUESTIONS = [
  "¿Qué quieres obtener: una categoría, un número, una recomendación, una alerta o un contenido?",
  "¿Qué datos tienes: etiquetados o no, texto, imágenes, series temporales o registros?",
  "¿Cuánto necesitas explicar cada resultado ante clientes, auditores o reguladores?",
  "¿Qué volumen de datos hay y qué recursos técnicos puedes mantener?",
  "¿Qué cuesta más: un falso positivo o un falso negativo?",
];

export const AI_LIFECYCLE = [
  { title: "Comprensión del negocio", text: "Qué decisión se quiere mejorar, qué error es aceptable y cómo se medirá el éxito." },
  { title: "Comprensión de los datos", text: "Fuentes, volumen, representatividad, sesgos, etiquetado y legalidad de su uso." },
  { title: "Preparación", text: "Limpieza, valores ausentes, codificación, escalado y separación entre entrenamiento y prueba." },
  { title: "Modelado", text: "Se prueban varios enfoques y se ajustan con criterios explícitos, no por moda." },
  { title: "Evaluación", text: "Métricas adecuadas al problema, análisis por grupos y validación con datos nuevos." },
  { title: "Despliegue y vigilancia", text: "Validar, registrar, aprobar, desplegar en entorno controlado, monitorizar y actualizar." },
];

export const DATA_TASKS = [
  ["Limpieza", "Corregir errores, duplicados e incoherencias: para un sistema, «sí», «Sí», «SI» y «si» son cuatro valores distintos."],
  ["Valores ausentes", "Decidir si se eliminan, se imputan o se revisan, sin borrar señales importantes."],
  ["Codificación", "Convertir categorías de texto en un formato numérico que el modelo entienda."],
  ["Escalado", "Poner en escalas comparables variables como edad e importe para que ninguna domine sin motivo."],
  ["Reducción", "Eliminar información redundante o irrelevante que solo añade ruido."],
  ["Equilibrio de clases", "Comprobar si una categoría aparece mucho más que otra y corregirlo."],
];

export const DATA_QUESTIONS = [
  "¿Qué datos existen y de dónde proceden?",
  "¿Son fiables y están actualizados?",
  "¿Representan bien la realidad o a todos los grupos afectados?",
  "¿Qué error sería aceptable y qué impacto tendría una mala predicción?",
];

export const MODEL_EVALUATION = [
  {
    title: "Más allá del porcentaje de aciertos",
    text: "Un 98 % de acierto puede esconder un modelo inútil: si detecta una enfermedad poco frecuente, puede acertar casi siempre diciendo que nadie la tiene. Por eso se combinan métricas como precisión, sensibilidad (recall) y F1, y se elige la que refleja el coste real de cada tipo de error.",
  },
  {
    title: "Detectar el sobreajuste",
    text: "El overfitting aparece cuando el modelo memoriza los datos de entrenamiento y falla con casos nuevos. Se detecta comparando resultados en entrenamiento y validación, y se corrige simplificando el modelo, regularizando, deteniendo antes el entrenamiento o recogiendo datos más variados.",
  },
  {
    title: "Analizar por grupos",
    text: "Una métrica global puede parecer buena y esconder diferencias importantes. Revisamos el error por antigüedad, zona, canal, tipo de cliente o condiciones de captura de las imágenes para descubrir a quién perjudica el modelo.",
  },
  {
    title: "Vigilar tras el despliegue",
    text: "Los datos cambian con el tiempo y el modelo puede perder calidad sin que nadie lo note. Monitorizamos rendimiento, latencia, errores, sesgos y cambios en los datos de entrada, con un plan de actualización o retirada.",
  },
];

export const RESPONSIBLE_PRINCIPLES = [
  ["Equidad", "El sistema no debe ofrecer resultados peores o injustos a determinados grupos."],
  ["Transparencia", "Las personas pueden conocer la finalidad, el funcionamiento general y los límites del sistema."],
  ["Explicabilidad", "Cuanto mayor es el impacto sobre una persona, más importante es poder justificar el resultado."],
  ["Responsabilidad", "No vale decir «lo decidió el algoritmo»: detrás hay personas que definieron objetivos, datos y usos."],
  ["Privacidad", "Solo los datos necesarios, anonimizados o seudonimizados cuando es posible, con accesos limitados y plazos de conservación."],
  ["Supervisión humana", "En decisiones sensibles, la IA apoya, prioriza o alerta, pero una persona revisa y se puede reclamar."],
];

export const AI_GLOSSARY = [
  ["Algoritmo", "Conjunto ordenado de instrucciones que permite resolver un problema o realizar una tarea concreta."],
  ["Modelo", "Resultado de entrenar un algoritmo con datos: la pieza que después hace predicciones sobre casos nuevos."],
  ["Entrenamiento", "Proceso en el que el modelo ajusta sus parámetros a partir de ejemplos para reducir su error."],
  ["Característica", "Variable de entrada que el modelo utiliza para aprender patrones, como la edad o el importe medio."],
  ["Clasificación", "Asignar una categoría a una entrada: spam o no spam, pieza correcta o defectuosa."],
  ["Regresión", "Predecir un valor numérico: ventas del próximo mes, demanda de energía o tiempo de entrega."],
  ["Clustering", "Agrupar datos similares entre sí sin categorías definidas de antemano."],
  ["Red neuronal", "Modelo formado por capas de unidades matemáticas que aprenden relaciones complejas entre los datos."],
  ["Atención", "Mecanismo de los modelos avanzados que asigna más importancia a ciertas partes de la entrada."],
  ["Overfitting", "Situación en la que el modelo funciona muy bien con los datos de entrenamiento pero falla con datos nuevos."],
  ["Sesgo algorítmico", "Resultados injustos o peores para determinados grupos, heredados de los datos o del diseño."],
  ["Explicabilidad", "Capacidad de explicar de forma comprensible cómo se ha obtenido un resultado."],
  ["AutoML", "Herramientas que automatizan parte de la creación, el entrenamiento y la comparación de modelos."],
  ["MLOps", "Prácticas para ordenar el ciclo de vida del modelo: validación, aprobación, despliegue, monitorización y retirada."],
  ["Minimización de datos", "Principio que obliga a usar solo los datos necesarios para la finalidad prevista."],
  ["Prueba de concepto", "Versión mínima que valida la hipótesis más incierta de un proyecto antes de invertir en él."],
];
